import type {MakeRequest, RestResponse} from './request'

export class ChatApi {
  constructor(private makeRequest: MakeRequest) {}
  fetchChats = async (): Promise<RestResponse<any>> => {
    return this.makeRequest.newRequest<any>({
      endpoint: 'v2/chat',
      method: 'GET',
    })
  }
  fetchChat = async (chatId: string): Promise<RestResponse<any>> => {
    return this.makeRequest.newRequest<any>({
      endpoint: `v2/chat/${chatId}`,
      method: 'GET',
    })
  }
  createChat = async (params: {
    productHash: string
  }): Promise<RestResponse<any>> => {
    const {productHash} = params
    return this.makeRequest.newRequest<any>({
      endpoint: 'v2/chat',
      method: 'POST',
      body: {
        product_hash: productHash,
      },
    })
  }
  fetchChatMessages = async (chatId: string): Promise<RestResponse<any>> => {
    return this.makeRequest.newRequest<any>({
      endpoint: `v2/chat/${chatId}/message`,
      method: 'GET',
    })
  }
  deleteChat = async (chatId: string): Promise<RestResponse<any>> => {
    return this.makeRequest.newRequest<any>({
      method: 'DELETE',
      endpoint: `v2/chat/${chatId}`,
    })
  }

  createNewMessage = async (params: {
    chatId: string
    text: string
  }): Promise<RestResponse<any>> => {
    const {chatId, text} = params

    return this.makeRequest.newRequest<any>({
      method: 'POST',
      endpoint: `v2/chat/${chatId}/message`,
      body: {
        text,
      },
    })
  }

  markAsRead = async (params: {
    chatId: string
    messageId: string
  }): Promise<RestResponse<any>> => {
    const {chatId, messageId} = params

    return this.makeRequest.newRequest<any>({
      method: 'POST',
      endpoint: `v2/chat/${chatId}/${messageId}/read`,
      body: {
        chat_id: chatId,
        message_id: messageId,
      },
    })
  }
}
